import { Divider, List, ListItem, Typography } from "@mui/material";
import clsx from "clsx";
import { FC, Fragment, memo } from "react";
import { WebShopIcon } from "../../WebShopIcon";
import { ContactsListProps } from "../lib/type";

export const ContactsList: FC<ContactsListProps> = memo(({ items }) => {
  return (
    <List className={"flex flex-col md:gap-3"}>
      {items.map(({ icon, name, href }, idx) => (
        <Fragment key={name}>
          {idx > 0 && <Divider className={"hidden max-md:block"} />}
          <ListItem key={name} className={clsx("max-md:px-4 max-md:py-[14px]")}>
            <a
              href={`tel:${href}`}
              className={"flex items-center gap-2 max-md:gap-3"}
            >
              {icon && (
                <Typography className={"h-5 w-5"}>
                  <WebShopIcon
                    name={icon.name}
                    fill={icon.color ?? undefined}
                    width={20}
                    height={20}
                  />
                </Typography>
              )}
              <Typography>{name}</Typography>
            </a>
          </ListItem>
        </Fragment>
      ))}
    </List>
  );
});

ContactsList.displayName = "ContactsList";
